"use strict";


/*****************
 ** WEBPACK FOOTER
 ** ./components/locale-provider/style/index.js
 ** module id = 197
 ** module chunks = 0
 **/